/*
 * Copyright (c) 2021-2025.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React from 'react';

import PropTypes from 'prop-types';
import DialogButton from "./DialogButton.jsx";
import FloatingElement from "../FloatingElement.jsx";
import {motion} from "motion/react";

class SmallDialogComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {

        return (
            <>
                <FloatingElement targetRef={{current: document.querySelector(this.props.querySelector)}} width={323}
                                 height={200}
                                 placement={'bottom-start'}>
                    <motion.div
                        initial={{
                            y: -40,
                            opacity: 0.4,
                        }}
                        animate={{
                            y: 0,
                            opacity: 1,
                            width: "100%"
                        }}
                        exit={{
                            y: -40,
                            opacity: 0
                        }}
                        className={"z-50"}
                        transition={{type: "spring", stiffness: 300, damping: 20, duration: 0.1}}
                    >
                        <div
                            className="ring-1 ring-black ring-opacity-5 bg-white  rounded-lg shadow-2xl transition-all duration-150 flex-1 ">
                            <div
                                className="align-bottom   text-left overflow-hidden w-full h-full flex flex-col shrink-0 ">
                                {(this.props.title !== undefined && this.props.title !== "" && this.props.title !== "New Dialog") && (
                                    <div className=" pr-2 pb-1 h-9 w-full border-b">
                                        <div className="mt-2">
                                            <p className="text-sm text-gray-600 overflow-ellipsis overflow-hidden font-semibold  truncate px-3">
                                                {this.props.title}
                                            </p>
                                        </div>
                                    </div>)}


                                <div
                                    className=" px-3 py-3  flex-grow  ">
                                    {this.props.children}
                                </div>
                                <DialogButton button={this.props.button}
                                              className={"flex-shrink-0 px-2  py-2 flex bg-stone-50  space-x-3 rounded-b-lg"}/>
                            </div>
                        </div>


                    </motion.div>


                </FloatingElement>


                {/*<Transition in={this.props.isOpen} mountOnEnter={true} unmountOnExit={true}*/}
                {/*            timeout={20}>*/}
                {/*    {state => (*/}
                {/*        <Popper placement="bottom-start"*/}
                {/*                referenceElement={document.querySelector(this.props.querySelector)}*/}
                {/*                modifiers={[*/}
                {/*                    {*/}
                {/*                        name: 'preventOverflow',*/}
                {/*                        options: {*/}
                {/*                            boundary: document.getElementById('root'),*/}
                {/*                        },*/}
                {/*                    },*/}
                {/*                    {*/}
                {/*                        name: 'flip',*/}
                {/*                        options: {*/}
                {/*                            fallbackPlacements: ['top-start', 'top-end', 'bottom-end'],*/}
                {/*                            rootBoundary: 'document',*/}
                {/*                            boundary: document.getElementById('root'),*/}

                {/*                        },*/}
                {/*                    }, {*/}
                {/*                        name: "offset",*/}
                {/*                        enabled: true,*/}
                {/*                        options: {*/}
                {/*                            offset: ({placement, reference, popper}) => {*/}
                {/*                                switch (placement) {*/}
                {/*                                    case 'top-end':*/}
                {/*                                    case 'top-start':*/}
                {/*                                    case 'top':*/}
                {/*                                    default:*/}
                {/*                                        return [0, 1]*/}


                {/*                                }*/}
                {/*                            },*/}
                {/*                        }*/}
                {/*                    }*/}
                {/*                ]}>*/}
                {/*            {({ref, style, placement, arrowProps}) => (*/}
                {/*                <div ref={ref}*/}
                {/*                     style={{...style, ...{width: "300px", zIndex: 999}}}*/}
                {/*                     data-placement={placement}*/}
                {/*                >*/}
                {/*                    <div style={{*/}
                {/*                        ...defaultStyle,*/}
                {/*                        ...transitionStyles[state]*/}
                {/*                    }}*/}
                {/*                         className="border border-gray-300 rounded-b bg-white  z-100 rounded-lg shadow-xl transition-all duration-150 flex-1">*/}
                {/*                        <div*/}
                {/*                            className="inline-block align-bottom   text-left overflow-hidden w-full h-full flex flex-col h-full shrink-0 ">*/}
                {/*                            {(this.props.title !== undefined && this.props.title !== "") && (*/}
                {/*                                <div className=" pr-2 pb-1 h-9 w-full border-b">*/}
                {/*                                    <div className="mt-2">*/}
                {/*                                        <p className="text-sm text-gray-500 overflow-ellipsis overflow-hidden truncate px-3">*/}
                {/*                                            {this.props.title}*/}
                {/*                                        </p>*/}
                {/*                                    </div>*/}
                {/*                                </div>)}*/}


                {/*                            <div*/}
                {/*                                className=" px-3 py-3  flex-grow  ">*/}
                {/*                                {this.props.children}*/}
                {/*                            </div>*/}
                {/*                            <DialogButton button={this.props.button}*/}
                {/*                                          className={"flex-shrink-0 px-2  py-2 flex bg-gray-50 border-t space-x-3 rounded-b-lg"}/>*/}
                {/*                        </div>*/}
                {/*                    </div>*/}

                {/*                </div>)}*/}
                {/*        </Popper>*/}
                {/*    )}*/}
                {/*</Transition>*/}
            </>
        )

    };
}

export default SmallDialogComponent;

SmallDialogComponent.propTypes = {
    /**
     * Bool value to open the panel
     * @default false
     */
    isOpen: PropTypes.bool,

    text: PropTypes.string,
    onButtonClick: PropTypes.func,

}

SmallDialogComponent.defaultProps = {
    text: 'Small dialog text',
    isOpen: false,
}